import React from 'react';
import ivclass from '@invideoio/web-shared/Modules/IVClass';
import { HeaderWithoutPosterType } from '../../types';
import Title from '@components/hero-section-v2/Title';

interface HeroSectionProps {
  heroSection: HeaderWithoutPosterType;
}

const HeroSection = ({ heroSection }: HeroSectionProps) => {
  const { Heading: heading, SideText: sideText } = heroSection;
  return (
    <div
      className={ivclass(
        'iv-grid',
        'iv-grid-cols-12 md:iv-grid-cols-8 sm:iv-grid-cols-4',
        'iv-gap-x-40 md:iv-gap-x-25 sm:iv-gap-x-20',
        'iv-mt-100 lg:iv-mt-80 md:iv-mt-75 sm:iv-mt-50 lg:iv-px-40 md:iv-px-25 iv-px-20',
        'xl:iv-ml-10 lg:iv-ml-8',
      )}
    >
      <div
        className={ivclass(
          'iv-col-span-12 md:iv-col-span-8 sm:iv-col-span-4',
          'xl:iv-col-start-1 lg:iv-col-start-2 lg:iv-col-end-12 sm:iv-col-start-1',
          'xl:iv-px-15 lg:iv-px-20 iv-w-full',
          'iv-text-center',
        )}
      >
        <Title heading={heading} />
      </div>

      <div
        className={ivclass(
          'iv-col-span-12 md:iv-col-span-8 sm:iv-col-span-4',
          'iv-col-start-3 iv-col-end-11 md:iv-col-start-2 md:iv-col-end-8 sm:iv-col-start-1',
          'iv-pt-50 md:iv-pt-60 sm:iv-pt-40',
        )}
      >
        <div
          className={ivclass(
            'xl:iv-text-heading-3xs lg:iv-text-heading-4xs md:iv-text-heading-4xs sm:iv-text-body-2xl',
            'xl:iv-m-heading-3xs lg:iv-m-heading-4xs md:iv-m-heading-4xs sm:iv-m-body-2xl',
            'iv-font-semibold iv-text-center',
            'xl:iv-px-5',
          )}
        >
          <span
            className={ivclass(
              'iv-text-black-50',
              'lg:iv-block md:iv-inline sm:iv-inline',
            )}
          >
            {sideText.plainText1}
          </span>
          {sideText.plainText2 && (
            <span
              className={ivclass(
                'iv-text-black-50',
                'iv-block md:iv-inline sm:iv-inline',
              )}
            >
              {sideText.plainText2}
            </span>
          )}
        </div>
      </div>
    </div>
  );
};

export default HeroSection;
